var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("model-provider", {
    attrs: { service: _vm.service, "model-id": _vm.id },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var model = ref.model
          return [
            _c(
              "b-card",
              { staticClass: "flex flex-col gap-4" },
              [
                _c("contact-form", {
                  ref: "form",
                  attrs: { model: model },
                  on: {
                    reset: function($event) {
                      return _vm.$router.back()
                    },
                    submit: _vm.storeContact
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "reset-button-text",
                        fn: function() {
                          return [_vm._v(" Voltar ")]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                })
              ],
              1
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }